import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { NgxPaginationModule } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';

import { ZARcurrencyPipe } from '@lmsSharedPipes';

import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';
import { LmsTableWrapperComponent } from '../../ui/lms-table-wrapper/lms-table-wrapper.component';

async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-client-change-log-report',
  templateUrl: './client-change-log-report.component.html',
  styleUrls: ['./client-change-log-report.component.scss'],
   standalone: true,
    imports: [CommonModule, FormsModule, ZARcurrencyPipe, NgxPaginationModule, LmsModalFrameComponent, LmsTableWrapperComponent],
})
export class ClientChangeLogReportComponent implements OnInit{

  clientChangeLogList: any[] = [];

  title = 'export-excel';
  fileName = '';

  @ViewChild('TABLE') table: ElementRef;

  dataSource = this.clientChangeLogList;
    config = {
    id: 'pager',
    itemsPerPage: 10,
    currentPage: 1,
  };

  docCount = 1;

  constructor(public global_utility: AppUtilityService, public dialogRef: MdbModalRef<ClientChangeLogReportComponent>) { }

    exportLogsToExcel(): void {
    this.title = 'export-excel';
    this.fileName = `CLient Change Log Report_${new Date()}.xlsx`;

    this.global_utility.startLoading('Exporting data to Excel.');
    loadXLSX()
      .then((XLSX) => {
         /* pass here the table id */
        //const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.lstQuotes);
        // table_to_sheet(this.lstQuotes);
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);

        /* generate workbook and add the worksheet */

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */

        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        console.error('Failed to import Excel:', err);
      });
  }
  ngOnInit(): void {
   console.log('ClientChangeLogReportComponent initialized');
    console.log(this.clientChangeLogList);
  }

  close() {
    this.dialogRef.close();
  }

}
